module.exports = __webpack_public_path__ + "img/bg_milk_used@2x.fe796317.png";